// @flow
import React, { Component } from 'react';

import languages from 'data/languages.json';
import LanguageSelectModal from 'components/modals/LanguageSelectModal';
import TabbedMenu from './TabbedMenu';
import './LocalizedMenu.scss';

type Props = {
  languages: Array<string>,
  contents: { string: React$Element<*> },
  icons: { string: React$Element<*> },
  showAddLanguage: boolean,
  onUpdateLanguages: Function,
  onTabClick: Function,
  languagesAllowedToToggle?: Array<string>,
  defaultLangAutoSelect?: boolean,
};

export default class LocalizedMenu extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      isModalOpen: false,
    };
  }

  handleClickAdd = () => {
    this.setState({
      isModalOpen: true,
    });
  }

  handleModalCancel = () => {
    this.setState({
      isModalOpen: false,
    });
  }

  handleModalConfirm = (tabs: Array<string>) => {
    if (tabs.length === 0) {
      alert('You need to select at least one language');
      return;
    }

    if (this.props.onUpdateLanguages) {
      this.props.onUpdateLanguages(tabs);
    }
    this.setState({
      isModalOpen: false,
    });
  }

  render() {
    return (
      <div className="localized-menu">
        <TabbedMenu
          allowedTabs={languages}
          tabs={this.props.languages}
          contents={this.props.contents}
          icons={this.props.icons}
          showAddTab={this.props.showAddLanguage}
          handleClickAdd={this.handleClickAdd}
          handleTabClick={this.props.onTabClick}
        />
        <LanguageSelectModal
          open={this.state.isModalOpen}
          onCancel={this.handleModalCancel}
          onConfirm={this.handleModalConfirm}
          defaultSelectedLangs={this.props.languages}
          languagesAllowedToToggle={this.props.languagesAllowedToToggle}
          defaultLangAutoSelect={this.props.defaultLangAutoSelect}
        />
      </div>
    );
  }
}

LocalizedMenu.defaultProps = {
  defaultLangAutoSelect: true,
  languagesAllowedToToggle: [],
};
